export const LOADING_STEP = 'loading';
export const PINWHEEL_STEP = 'pinwheel';
export const NON_PINWHEEL_STEP = 'nonPinwheel';
export const PERPAY_SPLIT_STEP = 'perpaySplit';
export const PINWHEEL_SPLIT_STEP = 'pinwheelSplit';
export const PAYROLL_PAYMENT_SETUP_STEP = 'payrollPaymentSetupStep';
export const PAYROLL_PAYMENT_SETUP_SUCCESS_STEP =
    'payrollPaymentSetupSuccessStep';

export const PAYMENT_SETUP_STEPS = [
    LOADING_STEP,
    PINWHEEL_STEP,
    NON_PINWHEEL_STEP,
    PERPAY_SPLIT_STEP,
    PINWHEEL_SPLIT_STEP,
    PAYROLL_PAYMENT_SETUP_STEP,
    PAYROLL_PAYMENT_SETUP_SUCCESS_STEP,
];
